import {RRule} from 'rrule';

const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const rule1 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.MO, RRule.WE],
  dtstart: new Date("2025-04-16T15:00:00-07:00"),
  until: new Date("2025-08-04T16:00:00-07:00"),
});

const rule2 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.MO, RRule.WE],
  dtstart: new Date("2025-07-02T16:00:00-07:00"),
  until: new Date("2025-08-27T17:00:00-07:00"),
});

const rule3 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.SA],
  dtstart: new Date("2025-04-26T11:00:00-07:00"),
  until: new Date("2025-06-07T12:00:00-07:00"),
});

const rule4 = new RRule({
  freq: RRule.WEEKLY,
  byweekday: [RRule.SA],
  dtstart: new Date("2025-04-26T14:00:00-07:00"),
  until: new Date("2025-05-31T15:00:00-07:00"),
});

const dates1 = rule1.all();
const dates2 = rule2.all();
const dates3 = rule3.all();
const dates4 = rule4.all();

const skipDate3 = new Date("2025-05-17T11:00:00-07:00");
const skipDate4 = new Date("2025-05-17T14:00:00-07:00");

const recurringEvent1 = dates1.map(date => (
  {
    title: "Mastering Smart Manufacturing: AI, IoT & Cyber-Physical Systems",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 3 - 4pm PDT`,
    description: "Get ready to dive into the world of Smart Manufacturing with AI, IoT, and Cyber-Physical Systems at our event!",
    url: "https://www.eventbrite.ca/e/mastering-smart-manufacturing-ai-iot-cyber-physical-systems-tickets-1289375730519?aff=ebdsoporgprofile"
  }
))

const recurringEvent2 = dates2.map(date => (
  {
    title: "AI in Healthcare and Applications",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 4 - 5pm PDT`,
    description: "Unlock the future of healthcare with AI! Learn ML, NLP, deep learning & real-world apps—from radiology to precision medicine.",
    url: "https://www.eventbrite.ca/e/ai-in-healthcare-and-applications-tickets-1424998993349?aff=ebdsoporgprofile"
  }
))

const recurringEvent3 = dates3.filter(date => date.toISOString() !== skipDate3.toISOString()).map(date => (
  {
    title: "Canada's Green Economy & AI: Shaping a Sustainable Future with AI",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 11am - 12pm PDT`,
    description: "Join us to explore how AI is driving Canada's green economy towards a sustainable future!",
    url: "https://www.eventbrite.ca/e/canadas-green-economy-ai-shaping-a-sustainable-future-with-ai-tickets-1278527693749?aff=ebdsoporgprofile"
  }
))

const recurringEvent4 = dates4.filter(date => date.toISOString() !== skipDate4.toISOString()).map(date => (
  {
    title: "Intro to Python Series",
    start: date,
    end: new Date(date.getTime() + 60 * 60 * 1000), // 1 hr duration
    dateTime: `${weekdays[new Date(date).getDay()]}, ${monthNames[new Date(date).getMonth()]} ${new Date(date).getDate()} · 2 - 3pm PDT`,
    description: "Kickstart your coding journey with Python! Join our 11-week series and learn coding fundamentals, data structures, and more!",
    url: "https://www.eventbrite.ca/e/intro-to-python-series-tickets-1269560612969?aff=ebdsoporgprofile"
  }
))

const oneTimeEvents = [
  {
    // id: 1,
    title: "Game-changing Data Transformations: Analyzing NBA Data for Competitive Edge",
    start: new Date(2025, 6, 12, 14, 0, 0), // Month starts from 0
    end: new Date(2025, 6, 12, 15, 0, 0), // Month starts from 0
    dateTime: "Saturday, July 12 · 2 - 3pm PDT",
    description: "Master data transformation techniques to unlock deeper insights and build flexible analytical models.",
    url: "https://www.eventbrite.ca/e/data-mastery-series-unleash-your-insights-transform-your-industry-tickets-1393374122509?aff=ebdsoporgprofile"
  },
  {
    id: 2,
    title: "Revolutionize Healthcare Insights: Advanced Visualizations for Informed Decision Making",
    start: new Date(2025, 6, 19, 14, 0, 0), // Month starts from 0
    end: new Date(2025, 6, 19, 15, 0, 0), // Month starts from 0
    dateTime: "Saturday, July 19 · 2 - 3pm PDT",
    description: "Leverage advanced visual tools in Power BI to explore complex data and guide strategic decisions.",
    url: "https://www.eventbrite.ca/e/data-mastery-series-unleash-your-insights-transform-your-industry-tickets-1393374122509?aff=ebdsoporgprofile"
  },
  {
    // id: 3,
    title: "Cracking the Code: Demystifying Star Schema for Sales Optimization",
    start: new Date(2025, 6, 26, 14, 0, 0), // Month starts from 0
    end: new Date(2025, 6, 26, 13, 0, 0), // Month starts from 0
    dateTime: "Saturday, July 26 · 2 - 3pm PDT",
    description: "Understand the fundamentals of star schema modeling to create scalable and optimized data structures.",
    url: "https://www.eventbrite.ca/e/data-mastery-series-unleash-your-insights-transform-your-industry-tickets-1393374122509?aff=ebdsoporgprofile"
  },
  {
    // id: 4,
    title: "Unlocking Success: Expert Tips for Effective Data Publishing using Supply Chain Analytics",
    start: new Date(2025, 7, 2, 14, 0, 0), // Month starts from 0
    end: new Date(2025, 7, 2, 15, 0, 0), // Month starts from 0
    dateTime: "Thursday, August 02 · 2 - 3pm PDT",
    description: "Learn best practices for publishing and sharing Power BI reports that drive action across teams.",
    url: "https://www.eventbrite.ca/e/data-mastery-series-unleash-your-insights-transform-your-industry-tickets-1393374122509?aff=ebdsoporgprofile"
  },
];

export const EventCalendarData = oneTimeEvents
  .concat(recurringEvent1)
  .concat(recurringEvent2)
  .concat(recurringEvent3)
  .concat(recurringEvent4)